

















































































































































/** @format */
import {
  thirdpayDetail,
  IthirdpayDetail,
  exportThirdpayExport,
  exportLocalcashDetailExport,
  exportThirdpayDetailExport
} from '@/api/reconciliation-management/index';
import { Component, Vue, Mixins } from 'vue-property-decorator';

import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import OrganizationSearch from '@/components/organization-search/index.vue';

import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';

import Utils from '@root/utils/common';

import { payMethodsMap } from '../../../types/order-management/dictionaries';

import {
  checkTypeMap,
  onLinePlatformMap,
  detailReconciliationResultMap
} from '../../../types/reconciliation-management/dictionaries';
import moment from 'moment';
import RangePickerBox from '@/components/range-picker-box/index.vue';

const defaultParams = {
  parkId: [],
  chkDayStart: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
  chkDayEnd: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
  thirdPlatform: [],
  checkType: [],
  platformTradeNo: '',
  thirdTradeNo: '',
  result: ''
};

@Component({
  name: 'OnlineDetail',
  components: {
    ParkingLotSearch,
    OrganizationSearch,
    RangePickerBox
  }
})
export default class OnlineDetail extends Mixins(TableMixin, TableWidthMixin) {
  // 对账平台
  private payMethodsList = Utils.toLabelVal(onLinePlatformMap);
  // 业务类型
  private checkTypeList = Utils.toLabelVal(checkTypeMap);
  // 对账结果
  private detailReconciliationResultList = Utils.toLabelVal(detailReconciliationResultMap);
  /**
   * table loading
   */
  private tableLoading: boolean = false;
  public filterParam = { ...defaultParams };
  clear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList,
      ...defaultParams
    };
    this.search();
  }
  public tableData: any[] = [];
  private sumRowData: any = {};
  get operateTime() {
    if (this.filterParam.chkDayStart && this.filterParam.chkDayEnd) {
      return [
        this.moment(this.filterParam.chkDayStart, 'YYYY-MM-DD'),
        this.moment(this.filterParam.chkDayEnd, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.chkDayStart) {
      return [this.moment(this.filterParam.chkDayStart, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  set operateTime(val: any) {}
  private created() {
    this.init();
    this.fetchTableData();
  }

  private init() {
    const { localTime, parkId, checkType, thirdPlatform } = this.$route.query;
    if (localTime) {
      this.filterParam.chkDayStart = localTime as string;
      this.filterParam.chkDayEnd = localTime as string;
    }
    if (parkId) {
      this.filterParam.parkId = [];
      this.filterParam.parkId.push(this.$route.query.parkId as string);
    }
    if (checkType) {
      this.filterParam.checkType = [];
      Object.keys(checkTypeMap).forEach((item: any) => {
        if (checkTypeMap[item] === checkType) {
          this.filterParam.checkType.push(item);
        }
      });
    }
    if (thirdPlatform) {
      this.filterParam.thirdPlatform = [];
      Object.keys(onLinePlatformMap).forEach((item: any) => {
        if (onLinePlatformMap[item] === thirdPlatform) {
          this.filterParam.thirdPlatform.push(item);
        }
      });
    }
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  public async fetchTableData() {
    try {
      // 时间跨度判断拦截 （单车场可跨365天，多车场最多可跨30天）

      const exitEnterTimeoffsetDays = this.filterParam.parkId.length === 1 ? 365 : 30;
      if (
        moment(this.filterParam.chkDayEnd).diff(moment(this.filterParam.chkDayStart), 'days') > exitEnterTimeoffsetDays
      ) {
        this.$message.warn(`查询条件：对账日期，跨度不可超过${exitEnterTimeoffsetDays}天`);
        return;
      }

      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkId,
        chkDayStart,
        chkDayEnd,
        thirdPlatform,
        checkType,
        platformTradeNo,
        thirdTradeNo,
        result
      } = this.filterParam;
      const { status, msg, code, data } = await thirdpayDetail({
        parkId: '' + parkId,
        chkDayStart,
        chkDayEnd,
        thirdPlatform: '' + thirdPlatform,
        checkType: '' + checkType,
        platformTradeNo,
        thirdTradeNo,
        currPage: this.current,
        pageSize: this.pageSize,
        result
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
          this.sumRowData = total;
          // this.tableData.push({
          //   ...total,
          //   parkName: '合计',
          //   isTotal: true,
          // })
        } else {
          this.tableData = [];
        }
        // this.pageSize = this.pageSize + 1
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderEnterList  接口调用错误');
    } finally {
      this.tableLoading = false;
    }
  }

  private async download() {
    try {
      const {
        parkId,
        chkDayStart,
        chkDayEnd,
        thirdPlatform,
        checkType,
        platformTradeNo,
        thirdTradeNo,
        result
      } = this.filterParam;
      await exportThirdpayDetailExport(
        {
          parkId: '' + parkId,
          chkDayStart,
          chkDayEnd,
          thirdPlatform: '' + thirdPlatform,
          checkType: '' + checkType,
          platformTradeNo,
          thirdTradeNo,
          result
        },
        '线上明细对账'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportThirdpayExport', '线上明细对账');
    }
  }

  private moment = moment;

  /**
   * 日期变化
   */
  private onChkDayChange(date: any, dateString: any) {
    let [chkDayStart, chkDayEnd] = dateString;
    this.filterParam.chkDayStart = chkDayStart;
    this.filterParam.chkDayEnd = chkDayEnd;
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'text-ellipse-to-tip' },
        width: 170
      },
      {
        title: '时间',
        dataIndex: 'chkDay',
        width: 180
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140
      },
      {
        title: '对账平台',
        dataIndex: 'thirdPlatform',
        width: 140
      },
      {
        title: '账户ID',
        dataIndex: 'thirdAccount',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },

      {
        title: '对账结果',
        dataIndex: 'result',
        width: 140
      },
      {
        title: '交易流水号',
        dataIndex: 'platformTradeNo',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },

      {
        title: '第三方交易流水号',
        dataIndex: 'thirdTradeNo',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '交易时间',
        dataIndex: 'tradeTime',
        width: 240
      },
      {
        title: '第三方对账平台',
        children: [
          {
            title: '业务类型',
            dataIndex: 'checkType',
            width: 140
          },
          {
            title: '交易金额',
            dataIndex: 'thirdTotalAmount',
            width: 140,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '手续费',
            dataIndex: 'fee',
            width: 140,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          },
          {
            title: '到账金额',
            dataIndex: 'realAmount',
            width: 140,
            customRender: (text: any, record: any, index: number) =>
              Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
          }
        ]
      }
    ];
  }

  toDetail() {}
}
